<template>
	<div>
		<app-ad></app-ad>

		<div class="pb-0">
			<v-container>
				<v-row>
					<v-col cols="12">
						<v-card flat color="transparent">
							<v-row>
								<v-col cols="12" class="pt-0">
									<v-expansion-panels>
										<v-expansion-panel>
											<v-expansion-panel-header disable-icon-rotate>
												<template #default="{ open }">
													<v-row no-gutters class="text-center">
														<v-col cols="12" class="text--secondary">
															<v-fade-transition leave-absolute>
																<span v-if="open" key="0">
																	التصفية
																	<v-icon color="primary" left>mdi-filter</v-icon>
																</span>
																<span v-else key="1">
																	التصفية
																	<v-icon color="primary" left>mdi-filter</v-icon>
																</span>
															</v-fade-transition>
														</v-col>
													</v-row>
												</template>
												<template #actions>
													<v-icon color="primary"></v-icon>
												</template>
											</v-expansion-panel-header>
											<v-expansion-panel-content>
												<v-row justify="center" dense>
													<v-col cols="12" class="py-0">
														<v-alert type="info" class="mb-1">
															لا يمكن عمل التصفية على الدول أو المناطق, التصفية تكون على المدن فقط
														</v-alert>
													</v-col>
													<v-col cols="12" md="4">
														<v-autocomplete
															v-model="filters.countryID"
															outlined
															hide-details="auto"
															label="الدولة"
															:items="countries"
															item-text="name"
															item-value="countryID"
															clearable
														></v-autocomplete>
													</v-col>
													<v-col cols="12" md="4">
														<v-autocomplete
															v-model="filters.regionID"
															outlined
															hide-details="auto"
															label="المنطقة"
															:items="regions"
															item-text="name"
															item-value="regionID"
															clearable
														></v-autocomplete>
													</v-col>
													<v-col cols="12" md="4">
														<v-autocomplete
															v-model="filters.cityID"
															:items="cities"
															hide-details
															outlined
															item-value="cityID"
															item-text="name"
															label="المدينة"
															clearable
														></v-autocomplete>
													</v-col>
													<v-col cols="12" md="4">
														<v-select
															v-model="filters.stateID"
															hide-details
															outlined
															label="الحالة"
															:items="states"
															item-text="text"
															item-value="value"
															clearable
														></v-select>
													</v-col>
													<!-- <v-col cols="12" md="4">
								<v-menu
									v-model="menu1"
									:close-on-content-click="false"
									:nudge-right="40"
									transition="scale-transition"
									offset-y
									min-width="290px"
								>
									<template v-slot:activator="{ on }">
										<v-text-field
											v-model="filters.startDate"
											outlined
											hide-details="auto"
											label="بداية تاريخ النشر"
											readonly
											clearable
											v-on="on"
										></v-text-field>
									</template>
									<v-date-picker v-model="filters.startDate" landscape></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12" md="4">
								<v-menu
									v-model="menu2"
									:close-on-content-click="false"
									:nudge-right="40"
									transition="scale-transition"
									offset-y
									min-width="290px"
								>
									<template v-slot:activator="{ on }">
										<v-text-field
											v-model="filters.endDate"
											outlined
											hide-details="auto"
											label="نهاية تاريخ النشر"
											readonly
											clearable
											v-on="on"
										></v-text-field>
									</template>
									<v-date-picker v-model="filters.endDate" landscape></v-date-picker>
								</v-menu>
													</v-col>-->
													<v-col cols="12" md="4">
														<v-select
															v-model="filters.specialtiesID"
															hide-details
															outlined
															label="التخصص"
															:items="specialites"
															item-text="name"
															item-value="specialtiesID"
															clearable
														></v-select>
													</v-col>
													<v-col cols="12" md="4">
														<v-select
															v-model="filters.itemsPerPage"
															hide-details
															outlined
															label="عدد الطلبات في الصفحة"
															:items="itemsPerPage"
														></v-select>
													</v-col>
													<v-col cols="12">
														<v-select
															v-model="filters.order"
															outlined
															label="الترتيب"
															:items="orders"
															item-text="text"
															item-value="value"
															hide-details
														></v-select>
													</v-col>
													<v-col cols="12" class="text-center">
														<v-btn color="success" @click="applyFilter">تصفية</v-btn>
													</v-col>
												</v-row>
											</v-expansion-panel-content>
										</v-expansion-panel>
									</v-expansion-panels>
								</v-col>
							</v-row>

							<v-row id="content" justify="start" :dense="$vuetify.breakpoint.mdAndUp">
								<v-col v-for="(record, index) in records" :key="record.id" cols="12" xl="6" :order="index + 1">
									<app-replacement-card :record="record" shaped></app-replacement-card>
								</v-col>

								<v-col cols="12" order="6">
									<app-ad middle></app-ad>
								</v-col>
							</v-row>

							<v-pagination v-model="page" :length="pageCount" class="pt-3"></v-pagination>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<app-ad></app-ad>

		<app-sponsors></app-sponsors>
	</div>
</template>

<script>
import client from "@/client";
export default {
	components: {
		"app-sponsors": require("@/components/general/AppSponsors").default,
		"app-replacement-card": require("@/components/cards/AppReplacementCard").default,
		"app-ad": require("@/components/general/AppAd").default
	},
	mixins: [require("@/mixins/router-mixin").default],
	data() {
		return {
			page: 1,
			pageCount: 1,
			records: [],
			orders: [
				{ text: "الأحدث اولاً", value: "newFirst" },
				{ text: "الاقدم اولاً", value: "oldFirst" }
			],
			specialites: [],
			filters: {
				stateID: null,
				specialtiesID: null,
				userID: null,
				startDate: null,
				endDate: null,
				order: 'newFirst',
				itemsPerPage: 12,
				cityID: null,
				countryID: null,
				regionID: null
			},
			states: [
				{ text: "منشورة", value: "published" },
				{ text: "مغلق", value: "closed" }
			],
			storedFilters: {
				itemsPerPage: 12
			},
			itemsPerPage: [12, 24, 36, 48, 60],
			menu1: false,
			menu2: false,
			users: [],
			countries: [],
			regions: [],
			cities: []
		};
	},
	watch: {
		page(newVal) {
			this.getRecords(newVal);
			this.$vuetify.goTo('#content');
		},
		"filters.countryID"(newVal) {
			this.filters.regionID = null;
			this.regions = [];
			this.getRegions(newVal);
		},
		"filters.regionID"(newVal) {
			this.filters.cityID = null;
			this.cities = [];
			this.getCities(newVal);
		}
	},
	mounted() {
		this.getRecords(1);
		this.getCountries();
		this.getSpecialties();
	},
	methods: {
		getSpecialties() {
			client
				.get("/api/replacements/specialtiesList")
				.then(response => {
					this.specialites = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getRecords(page) {
			client
				.post("/api/replacements/all?page=" + page, this.storedFilters)
				.then(response => {
					console.log(response);
					// this.pageCount = response.data.last_page;
					this.records = Object.values(response.data.data.data).map(
						record => {
							if (
								record.maleReplacement &&
								record.femaleReplacement
							) {
								record.gender = "بديل أو بديلة";
							} else if (record.maleReplacement) {
								record.gender = "بديل";
							} else if (record.femaleReplacement) {
								record.gender = "بديلة";
							}

							if (
								record.maleReplacement &&
								record.femaleReplacement
							) {
								record.genderIcon = "mdi-human-male-female";
							} else if (record.maleReplacement) {
								record.genderIcon = "mdi-human-male";
							} else if (record.femaleReplacement) {
								record.genderIcon = "mdi-human-female";
							}

							return record;
						}
					);
				})
				.catch(err => {
					console.log(err);
				});
		},
		applyFilter() {
			this.storedFilters = { ...this.filters };
			this.records = [];
			this.loading = true;
			this.getRecords(1);
		},
		getCountries() {
			client
				.get("/api/location/countries")
				.then(response => {
					this.countries = response.data.data;
					this.filters.countryID = "sa";
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getRegions(countryID) {
			client
				.post("/api/location/countryregions", { countryID: countryID })
				.then(response => {
					this.regions = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getCities(regionID) {
			client
				.post("/api/location/regioncities", { regionID: regionID })
				.then(response => {
					this.cities = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		}
	}
};
</script>